import React from 'react';

export default function Loader({ small }) {
  return (
    <div className={small ? 'loader loader--small' : 'loader'}>
      {/* Simple accessible loader */}
      <div role="status" aria-live="polite">
        <span className="visually-hidden"></span>
      </div>
    </div>
  );
}